export default {
  name: "Cgu",
  data() {
    return {
      versionNotFound: false,
      versionComponent: null
    };
  },
  async created() {
    document.title =
      "Conditions Générales d'Utilisation — Application Vitalliance";
    const versionName = this.$route.params.versionName;
    try {
      const module = await import(`./versions/Cgu_${versionName}.vue`);
      this.versionComponent = module.default;
      if (this.$route.query.print === "true") {
        this.$nextTick(() => window.print());
      }
    } catch (e) {
      this.versionNotFound = true;
    }
  },
  methods: {
    download() {
      const url = window.location.href.split("?")[0] + "?print=true";
      window.open(url, "_blank");
    }
  }
};
